import { Component, Input } from '@angular/core';
import { Item } from '../../item';
import { Button } from '../../button';
import { Observable } from 'rxjs';

@Component({
    selector: 'chassis-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {

    @Input() public items: Array<Item> = [];

    public isItemButton(item: Item): boolean {
        return item['callback']
            && typeof item['callback'] === 'function';
    }

    public isItemDropdown(item: Item): boolean {
        return item['items']
            && item['items'] instanceof Array
            && !item['callback'];
    }

    public isItemDisabled(item: Item): boolean {
        return item.disabled !== undefined
            && typeof item.disabled === 'function'
            && !!item.disabled()
    }

    public isItemAuthorized(item: Item): Observable<boolean> {
        if (item.authorized !== undefined) {
            if (item.authorized() instanceof Observable) {
                // console.log('entities: return observable', item.authorized());
                // return item.authorized();
                return Observable.of(true);
            } else if (item.authorized() instanceof Boolean) {
                return Observable.of(!!item.authorized());
            }
        }

        return Observable.of(true);
    }

    public isItemLoading(item): boolean {
        return item.loader !== undefined
            && typeof item.loader === 'function'
            && !!item.loader();
    }

    public getItemClasses(item: Item): string {
        return item.classes
            || 'btn-default'
    }

    public executeItemCallback(item: Button): void {
        if (this.isItemDisabled(item)) {
            return;
        }

        if (item.callback && typeof item.callback === 'function') {
            item.callback();
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/toolbar/components/toolbar/toolbar.component.ts